const state = {
  mseId: 0, // 城域网MSEID
  userName: ''
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js